import { render, staticRenderFns } from "./IconsInterface.vue?vue&type=template&id=4d7a0fce&scoped=true&"
import script from "./IconsInterface.vue?vue&type=script&lang=js&"
export * from "./IconsInterface.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7a0fce",
  null
  
)

export default component.exports